import React from 'react';
import { OverlayId, useOverlayLibraryStore } from '../../store/overlayLibraryStore';
import { X } from 'lucide-react';
import './InfoOverlayStack.css';

interface InfoOverlayItemProps {
  overlayId: OverlayId;
  children: React.ReactNode;
}

const InfoOverlayItem: React.FC<InfoOverlayItemProps> = ({ overlayId, children }) => {
  const isVisible = useOverlayLibraryStore((state) =>
    state.visibleOverlays.includes(overlayId)
  );
  const hideOverlay = useOverlayLibraryStore((state) => state.hideOverlay);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="info-overlay-item">
      <button
        className="info-overlay-close-btn"
        onClick={() => hideOverlay(overlayId)}
        title="Hide overlay"
      >
        <X size={10} />
      </button>
      <div className="info-overlay-item-content">
        {children}
      </div>
    </div>
  );
};

interface InfoOverlayStackProps {
  children: React.ReactNode;
}

const InfoOverlayStack: React.FC<InfoOverlayStackProps> = ({ children }) => {
  return (
    <div className="info-overlay-stack">
      {children}
    </div>
  );
};

export { InfoOverlayStack, InfoOverlayItem };
